<template>
  <v-container fluid>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.user') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="user" v-model="user.user" :items="userList" @update:search-input="searchUser" :label="$t('rtrck.ph.user')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.registrant') }} / {{ $t('rtrck.title.regist.term') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <v-autocomplete name="registrant" v-model="user.registrant" :items="registrantList" @update:search-input="searchRegistrant" :label="$t('rtrck.ph.user')" clearable dense flat hide-no-data hide-details solo> </v-autocomplete>
        </v-toolbar>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <div>
            <date-range-picker v-model="user.regTerm" :clearable="true" @click:clear="clearRegTerm"></date-range-picker>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.last.logon.term') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <div>
            <date-time-range-picker-neo v-model="user.logonTerm" :clearable="true" @click:clear="clearLogonTerm"></date-time-range-picker-neo>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.pass.chnage.term') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <div>
            <date-range-picker v-model="user.passTerm" :clearable="true" @click:clear="clearPassTerm"></date-range-picker>
          </div>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <span>{{ $t('rtrck.title.lock.status') }}</span>
      </v-col>
      <v-col cols="3">
        <v-toolbar dense flat height="32px">
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-select
            v-model="user.lockStatus" :items="lockStatusList"
            @focus="lockStatusFocus = true" @blur="lockStatusFocus = false"
            item-text="label" item-value="value" solo dense hide-details class="mr-1 w-auto">
            <template #append>
              <v-icon @click="clearLockStatus" :class="{ 'primary--text': lockStatusFocus }">mdi-close</v-icon>
              <v-icon v-if="!lockStatusFocus">mdi-menu-down</v-icon>
              <v-icon v-if="lockStatusFocus" class="primary--text">mdi-menu-up</v-icon>
            </template>
          </v-select>
        </v-toolbar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { isEmpty } from 'lodash';
import { api } from '@/api/common/instances';
export default {
  props: {
    params: {
      type: Object,
    },
  },
  data() {
    return {
      userList: [],
      registrantList: [],
      lockStatusList: [
        { label: this.$t('cd.039.'), value: '' },
        { label: this.$t('cd.039.0'), value: '0' },
        { label: this.$t('cd.039.32'), value: '32' },
        { label: this.$t('cd.039.64'), value: '64' },
        { label: this.$t('cd.039.128'), value: '128' },
      ],
      showRegTermMenu: false,
      showPassTermMenu: false,
      lockStatusFocus: false,
    };
  },
  computed: {
    ...mapState('extra/auth/role-tracker', ['user', 'initFilter']),
  },
  watch: {
    'user.user': {
      handler() {
        // 컴포넌트 'v-autocomplete'는 props 'value'가 undefined가 아닐 때에는
        // props 'items'에 value에 해당하는 element가 있어야만 그 값이 화면에 보여진다.
        this.userList = (() => {
          if (this.user.user === undefined) return [];
          else return [this.user.user];
        })();
      },
    },
    'user.registrant': {
      handler() {
        this.registrantList = (() => {
          if (this.user.registrant === undefined) return [];
          else return [this.user.registrant];
        })();
      },
    },
  },
  methods: {
    ...mapActions('extra/auth/role-tracker', ['setUser']),
    async searchUser(input) {
      // v-autocomplete 컴포넌트가 created() 되면 초기값이 null이어서 userList가 빈 array이어서 무한루프가 발생한다.
      // 최초에 props를 받아갔을 때도 event가 발생하여 이 함수에 도달하는데 - 이 때는 props 'params'가 초기화가 완료되기 전이다.
      // 이 두가지 경우를 체크하여 막아주어야 server API 호출이 정상적으로 이루어진다.
      if (input === null || input == this.user.user) return;
      this.userList = await this.autoSearch('user', { bname: input });
      // 실제 DB에 없는 사용자 명('%'문자가 포함된 것)을 입력할 수 있도록 현재 입력된 값을 items에 추가해준다.
      this.userList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async searchRegistrant(input) {
      if (input === null || input == this.user.registrant) return;
      this.registrantList = await this.autoSearch('user', { bname: input });
      this.registrantList.unshift(isEmpty(input) ? input : input.toUpperCase());
    },
    async autoSearch(uri, params) {
      const {
        data: { items },
      } = await api.get(`/rtrck/search/auto-search/${uri}`, {
        params: {
          ...this.params,
          ...params,
        },
      });
      return items;
    },
    clearRegTerm() {
      let u = {
        ...this.user,
      };
      u.regTerm = this.initFilter.user.regTerm;
      this.setUser(u);
    },
    clearLogonTerm() {
      let u = {
        ...this.user,
      };
      u.logonTerm = this.initFilter.user.logonTerm;
      this.setUser(u);
    },
    clearPassTerm() {
      let u = {
        ...this.user,
      };
      u.passTerm = this.initFilter.user.passTerm;
      this.setUser(u);
    },
    clearLockStatus() {
      let u = {
        ...this.user,
      };
      u.lockStatus = this.initFilter.user.lockStatus;
      this.setUser(u);
    },
  },
};
</script>

<style scoped>
.row-h-34 {
  height: 34px;
}
.col-1 {
  padding-top: 10px;
}
.datepick-width {
  width: 210px;
}
.v-toolbar ::v-deep .v-toolbar__content {
  padding: 4px;
}
</style>
